import { EnterpriseContactSalesPageTemplate } from '@/templates/enterprise/contact/enterprise-contact-sales-page/enterprise-contact-sales.template';

export const EnterpriseContactSalesPage = () => <EnterpriseContactSalesPageTemplate />;
